import { Button, CheckboxInput } from "@rocketmakers/armstrong";
import * as React from "react";
import { RouteComponentProps } from "react-router";
import { useRoutePaths } from "../../../../shared/context/paths";
import { BackButton } from "../../components/buttons/back-button";
import { routePaths } from "../../routes";
import "./checks.scss";

export const CheckRouterView: React.FunctionComponent<RouteComponentProps> = () => {
	const { push } = useRoutePaths();
	const routerChecks = [
		'Check that the green "RUN" LED on the router is FLASHING',
		<span key="check-antenna-led">
			Check that the antenna LED on the router is ON or FLASHING
			<br /> NOTE: this can take 5 minutes.
			{/* rome-ignore lint/a11y/useAltText: <explanation> */}
			<br /> <img className="check-img" src={require("../../../assets/images/installer/router-signal.jpg")} />
		</span>,
	];

	const handleContinue = () => push(routePaths.device.root);

	const [checklist, updateChecklist] = React.useState(routerChecks.map(() => false));
	const hasCompletedChecks = checklist.every((value) => value === true);

	return (
		<>
			<div>
				<BackButton />
				<h1>
					Router <span className="color-primary">checks</span>
				</h1>

				<div>
					{routerChecks.map((message, idx) => (
						<CheckboxInput
							// rome-ignore lint/suspicious/noArrayIndexKey: <explanation>
							key={idx}
							labelContent={message}
							checked={checklist[idx]}
							onChange={(e) => updateChecklist(checklist.map((value, i) => (idx === i ? e.target.checked : value)))}
						/>
					))}
				</div>

				<div className="row">
					<Button
						data-qa="continue-button"
						className="continue-button btn-full btn-large"
						disabled={!hasCompletedChecks}
						onClick={handleContinue}
					>
						Continue
					</Button>
				</div>
			</div>
		</>
	);
};
